import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-station-detail',
  templateUrl: './station-detail.component.html',
  styleUrls: ['./station-detail.component.scss']
})
export class StationDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
